$(function() {
  if ($('#compare_products').length || $('#comp-hats-wrapper').length) {
    if ($('#compare_products').length > 0) {
      var emptyhtml = $('.product-card-wp.empty').html();
    }
    if ($('#comp-hats-wrapper').length > 0) {
      var page_emptyhtml = $('.product-card-wp.empty').html();
    }
    var clicks = 0;
    var product_cnt = 0;
    var compare_products = [];
    if ($('#compare_products').length > 0) {
      function addproduct(handle) {
        $.get("/products/" + handle + "?view=compare_popup", function(
          datammm) {
          var parent_div = $('#compare_products').find(
            '.product-card-wp.empty:eq(0)');
          parent_div.html(datammm);
          parent_div.removeClass('empty').addClass('not_empty').attr(
            'data-product', handle);
          $('body').removeClass('has_load');
        });
      }
    }

    function addproduct_page(handle) {
      var href = "/products/" + handle + "?view=compare_item";
      $.ajax({
        type: 'GET',
        url: href,
        async: false,
        beforeSend: function() {},
        success: function(datammm) {
          var parent_div = $('#comp-hats-wrapper').find(
            '.product-card-wp.empty:eq(0)');
          parent_div.html(datammm);
          parent_div.removeClass('empty').addClass('not_empty').attr(
            'data-product', handle);
          product_cnt++;
        },
        dataType: "html"
      });
    }

    if (getCookie('compareproduct')) {
      var cookval = getCookie('compareproduct');
      var result = cookval.split(",");
      var leng = result.length;
      var i;
      if (leng > 4) {
        leng = 4;
      }
      for (i = 0; i < leng; i++) {
        var al_hand = result[i];
        compare_products.push(al_hand);
        if ($('#compare_products').length > 0) {
          addproduct(al_hand);
        }
        if ($('#comp-hats-wrapper').length > 0) {
          addproduct_page(al_hand);
          if (i == leng - 1) {
            setTimeout(function() {
              reheight();
            }, 400);
          }

        }
        clicks++;
      }
      if ($('#compare_products').length > 0) {
        if (clicks >= 4) {
          $('.compare-hat-option a').addClass('disabled').attr('disabled',
            'disabled');
        }
        document.onreadystatechange = function() {
          if (document.readyState !== "complete") {} else {
            if (getCookie('hasreturn')) {
              $('.col-filter .compare-hats').trigger('click');
              setCookie('hasreturn', false, -1);
            }
          }
        }
      }
    }

    if ($('#comp-hats-wrapper').length > 0) {
      $("body").on("click",
        '.comp-hats-wrapper .product-card-wp .remove-compare',
        function(e) {
          e.preventDefault();
          clicks--;
          if ($('#comp-hats-wrapper .hats_grid_items').hasClass(
              'slick-initialized')) {
            //           $('#compare_products .hats_grid_items').css('opacity','0');
            $('#comp-hats-wrapper .hats_grid_items').slick('destroy');
          }
          var remove_Item = $(this).closest('.product-card-wp').data(
            'product');
          var close = $(this).closest('.hats_grid_items');
          $(this).closest('.product-card-wp').remove();
          var newh = '<div class="product-card-wp empty">' +
            page_emptyhtml + '</div>';
          close.append(newh);
          compare_products = $.grep(compare_products, function(value) {
            return value != remove_Item;
          });
          setCookie('compareproduct', compare_products, 30);
          setTimeout(function() {
            $('#comp-hats-wrapper .hats_grid_items').slick('reinit');
          }, 100);
          reheight();
        });

      $("body").on("click", '.product-card-wp.empty .add-compare-product',
        function(e) {
          e.preventDefault();
          $('body').addClass('has_load');
          setCookie('hasreturn', true, 30);
          var referrer = document.referrer;
          window.location.href = referrer;
        });

      $("body").on("click", '#comp-hats-wrapper .clear-compare a', function(
        e) {
        e.preventDefault();
        compare_products = [];
        if (clicks > 0) {
          setCookie('compareproduct', false, -1);
          $('.hats_grid_items .product-card-wp.not_empty').html(
              page_emptyhtml).removeClass('not_empty').addClass('empty')
            .removeAttr('data-product');
          clicks = 0;
          reheight();
        }
      });

    }
  }
})

$(document).ready(function(){
  if ($('#product-{{ product.id }} .swatch-element.available.has_show').length) {
    $('#product-{{ product.id }} .swatch-element.available.has_show:eq(1) input')
      .trigger('change');

    setTimeout(function () {
      $('#product-{{ product.id }} .swatch-element.available.has_show:eq(0) input')
        .trigger('change');
    }, 300);

    $('#product-{{ product.id }} .quick-add').show();
  }
});
